import { ProviderFile } from "fileParsing/types";
import React from "react";

function PlaintextView({ files }: { files: ProviderFile[] }) {
  const plaintextPreview = new TextDecoder("utf-8").decode(
    files[Math.floor(Math.random() * files.length)].parserData?.byteData ?? new Uint8Array(),
  );
  return <pre>{plaintextPreview}</pre>;
}

export { PlaintextView };
